'use client';

import {styled} from '@mui/material/styles';
import {Box, ButtonBase} from '@mui/material';

export const StyledFooterContainer = styled('footer')(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.dark,
}));

export const StyledFooterDesktopGroupContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(6),
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  padding: theme.spacing(6, 6),
  '& > div': {
    flex: '1 1 180px',
    minWidth: 180, // ensures a column will wrap to the next line when it can't shrink below this
  },
}));

export const StyledFooterBottomContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(4, 6),
}));

export const StyledFooterGroupContainer = styled(Box)(() => ({
  display: 'flex', flexDirection: 'column', gap: 16
}));

export const StyledFooterCopyRightContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
}));

export const StyledFooterScrollUpContainer = styled(ButtonBase)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  background: 'transparent',
  border: 0,
  padding: 0,
  color: 'inherit',
  font: 'inherit',
}));

export const StyledSmScreenFooterContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 6),
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(2, 0),
  },
}));

export const StyledSmScreenCopyRightContainer = styled(Box)(({ theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(4, 0, 0, 0),
}));